import React from "react";
import { CurrencyLabel, StatusBadge } from "../../components";
import dayjs from "dayjs";
import { GRID_COLUMN_EMPTY_ICONS } from "../../utils/Constants";

export const DIRECT_DEBIT_PROVIDER = "DirectDebit";

// Direct Debit Status Constants
export const MANDATE_STATUS = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
};

export const PAYMENT_STATUS = {
  SUCCESS: "Success",
  FAILED: "Failed",
  PENDING: "Pending",
};

export const FREQUENCY_TYPE = {
  MONTHLY: "Monthly",
  TERM: "Term",
};

export const TRANSACTION_STATUS = {
  SUCCESS: "Success",
  FAILED: "Failed",
  PENDING: "Pending",
};

// Column definitions for AG Grid
export const COLUMN_DEFS = [
  {
    headerName: "DDA Reference No",
    field: "ddaReferenceNumber",
    valueFormatter: (params) => {
      const ddaReferenceNumber = params.data?.ddaReferenceNumber;
      return ddaReferenceNumber ?? "";
    },
    sortable: true,
    unSortIcon: true,
    suppressMenu: true,
    icons: GRID_COLUMN_EMPTY_ICONS,
    pinned: "left",
    flex: 1,
    minWidth: 200,
  },
  {
    headerName: "DDID",
    field: "mandateInfo.ddaId",
    valueFormatter: (params) => {
      return params.data?.mandateInfo?.ddaId ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Student ID",
    field: "beneficiary.studentId",
    valueFormatter: (params) => {
      return params.data?.beneficiary?.studentId ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Student name",
    field: "beneficiary.name",
    valueFormatter: (params) => {
      return params.data?.beneficiary?.name ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 160,
  },
  {
    headerName: "Mandate Status",
    field: "mandateInfo.mandateStatus",
    valueFormatter: (params) => {
      return params.data?.mandateInfo?.mandateStatus ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 160,
  },
  {
    headerName: "Service",
    field: "productDetails.productName",
    valueFormatter: (params) => {
      return params.data?.productDetails?.productName ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
  },
  {
    headerName: "Frequency",
    field: "productDetails.type",
    valueFormatter: (params) => {
      return params.data?.productDetails?.type ?? "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Next payment",
    field: "nextPaymentDate",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const d = dayjs(params.value);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 150,
  },
  {
    headerName: "Total amount",
    field: "totalAmount",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 130,
    cellRenderer: (params) => <CurrencyLabel amount={params.value ?? 0} />,
  },
  {
    headerName: "Status",
    field: "status",
    cellRenderer: (params) => <StatusBadge status={params.value} />,
    sortable: false,
    filter: false,
    suppressMenu: true,
    pinned: "right",
    flex: 1,
    minWidth: 110,
  },
];

// Page routes
export const PAGE_ROUTE = {
  DIRECT_DEBIT: "/skiply-portal/DirectDebit",
};

// Search/Filter options
export const SEARCH_CATEGORIES = [
  { label: "Student Name", value: "studentName" },
  { label: "Student ID", value: "studentId" },
  { label: "User ID", value: "userId" },
];

export const STATUS_FILTER_OPTIONS = [
  { label: "All Status", value: "" },
  { label: "Active", value: MANDATE_STATUS.ACTIVE },
  { label: "Cancelled", value: MANDATE_STATUS.CANCELLED },
  { label: "Completed", value: MANDATE_STATUS.COMPLETED },
];
